/*
  Explanation

  Note: Currently only displays stores with an approved landing page,
  if we want to change that, we'd update the 'where' on closest-pickup-location.liquid
  and hide the view store page button for those instances

  Requires:

*/
class LocationWidget extends HTMLElement {
  constructor() {
    super();

    this.label = this.querySelector(".buff-meganav__location-widget");
    this.content = this.querySelector(".buff-meganav__location-widget + .buff-meganav__dropdown > .buff-meganav__dropdown__column");

    if (!this.label && !this.content) return;

    this.zipcodeInput = null;
    this.findStoresBtn = null;
    this.allStores = null;
    this.updateLocationBtn = null;
    this.updateZipcodeBtn = null;
    this.actions = null; 

    this.closestStore = null;
    this.secondClosestStore = null;
  }

  setupListeners() {
    this.findStoresBtn?.addEventListener("click", async (e) => {
      // Show interface to update location
      this.findStores(e);
    });

    this.allStores?.forEach((store) => {
      store.addEventListener("click", async (e) => {
        // Show interface to update location
        this.findStores(e);
      });
    });

    this.updateLocationBtn?.addEventListener("click", async () => {
      const spinner = this.querySelector(".spinner");
      spinner?.classList.add("show"); // Show spinner
  
      console.log("debug - updateLocationBtn");
      await this.getZipcodeFromCoords();

      //let section know data is ready for it
      this.dispatchEvent(new CustomEvent("location-widget:ordered", {
        bubbles: true,
        detail: { 
          closestStore: this.closestStore, 
          secondClosest: this.secondClosestStore,
        }
      }));
  
      spinner?.classList.remove("show"); // Hide spinner
    });

    this.updateZipcodeBtn?.addEventListener("click", async () => {

      // Show interface to update location
      console.log("debug - updateZipcodeBtn");

      let zipcode = this.zipcodeInput.value;

      if (zipcode != null && zipcode.trim() !== ''){
        const spinner = this.querySelector(".spinner");
        spinner?.classList.add("show"); // Show spinner

        await this.getLocationFromZipcode(zipcode.trim());
        
        spinner?.classList.remove("show"); // Hide spinner

        //let section know data is ready for it
        this.dispatchEvent(new CustomEvent("location-widget:ordered", {
          bubbles: true,
          detail: { 
            closestStore: this.closestStore, 
            secondClosest: this.secondClosestStore,
          }
        }));
      }
    });
  }

  async getLocationFromZipcode(zipcode) {
    const apiUrl = `https://geoallocation.alisha-garric.workers.dev?address=${encodeURIComponent(zipcode)}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            const err = await response.json();
            throw new Error(`Network response was not ok: ${response.status} - ${JSON.stringify(err)}`);
        }
        const data = await response.json();
        console.log('debug - getLocationFromZipcode - geo response:', data);

        let userLocation = {
            lat: data.results[0].geometry.location.lat,
            lon: data.results[0].geometry.location.lng,
            zipcode: zipcode
        };
        window.sessionStorage.setItem("userLocation", JSON.stringify(userLocation));
        prepareStoresData(JSON.parse(window.sessionStorage.getItem("stores")), userLocation, false, false);
        this.reorderStores(this.content);
        this.injectCurrentZipcode(this.content);
    } catch (error) {
        console.error('Error:', error);
        // Handle error appropriately, e.g. show an alert
    } finally {
        // Always hide the spinner
        const spinner = this.querySelector(".spinner");
        spinner?.classList.remove("show");
    }
}

  async getZipcodeFromCoords() {
    let userLocation;

    const getCurrentPosition = () => {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(resolve, reject);
            } else {
                reject("Your browser cannot retrieve your location.");
            }
        });
    };

    try {
        const geolocationPosition = await getCurrentPosition();
      
        console.log(`${geolocationPosition.coords.latitude},${geolocationPosition.coords.longitude}`);
        const apiUrl = `https://geoallocation.alisha-garric.workers.dev/?latlng=${geolocationPosition.coords.latitude},${geolocationPosition.coords.longitude}`;
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        // Main fetch method to the lambda function
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            const err = await response.json();
            throw new Error(`Network response was not ok: ${response.status} - ${JSON.stringify(err)}`);
        }

        const data = await response.json();
        console.log("data", data);

        userLocation = {
            lat: geolocationPosition.coords.latitude,
            lon: geolocationPosition.coords.longitude,
            zipcode: data.results[0].address_components?.find(component => component.types.includes("postal_code"))?.short_name
        };

        window.sessionStorage.setItem("userLocation", JSON.stringify(userLocation));
        prepareStoresData(JSON.parse(window.sessionStorage.getItem("stores")), userLocation, false, false);
        this.reorderStores(this.content);
        this.injectCurrentZipcode(this.content);

    } catch (error) {
        if (error.message === "User denied Geolocation") {
            alert("You've blocked this site from accessing your location. Please update your location settings, or enter your zipcode instead.");
        } else {
            console.error('Error:', error);
            alert(error); // Display the error to the user
        }
    }
  }

  async findStores(e){
      console.log("debug - find stores");

      //Show interface to select new store
      if (this.actions.classList.contains("__inactive")) {
          this.actions.classList.remove("__inactive");

      //Update store with selected store and hide interface
      } else {
          let selectedStore = this.querySelector("input:checked");
          if (!selectedStore) return;

          let storesObject = JSON.parse(window.sessionStorage.getItem("stores"));
          let stores = storesObject.openStores;
          let oldPreferredStore = storesObject.preferred;
          let relUrl = selectedStore.dataset.relUrl;

          if (relUrl == oldPreferredStore.rel_url) return; //if the selected store is the same that's already displayed, abort

          let title = selectedStore.dataset.title;
          let lat = selectedStore.dataset.lat;
          let lon = selectedStore.dataset.lon;

          let matchingStore = stores.filter(item => {
              return item.rel_url === relUrl;
          })
          
          window.sessionStorage.setItem("stores", JSON.stringify({ //update stores data
              preferred: matchingStore[0],
              openStores: stores
          }));

          await this.injectClosestStore({ rel_url: relUrl, title: title });               
          this.actions.classList.add("__inactive");
          
      }
  }

  //if given a store, else grab the closest store, and inject its data into the dropdown
  async injectClosestStore(closestStore) {
      console.log("debug - injectClosestStore");


      if (!closestStore || !closestStore.title || !closestStore.rel_url) return;

      try {
          const response = await fetch(`${closestStore.rel_url}?section_id=meganav-closest-store-dropdown`);
          const text = await response.text();
          const html = new DOMParser().parseFromString(text, "text/html");
          const section = html.querySelector(".shopify-section");

          if (section) {
            //update hours to display todays hours
            this.updateHours(section);
            this.reorderStores(section);
            this.injectCurrentZipcode(section);

            //add content into the dropdown
            this.content.innerHTML = section.innerHTML;

            //add location title into the label
            this.label.querySelector('.buff-meganav__location-widget__title').innerHTML = closestStore.title;

            //establish elements within injected content to modify with listeners
            this.findStoresBtn = this.querySelector("#Find-stores");
            this.allStores = this.querySelectorAll(".buff-meganav__location-widget__stores__store label");
            this.updateLocationBtn = this.querySelector("#Update-location");
            this.updateZipcodeBtn = this.querySelector("#Update-zipcode");
            this.zipcodeInput = this.querySelector("#Location-zipcode");
            this.actions = this.querySelector(".buff-meganav__location-widget__actions");
            this.setupListeners();

            //let css show all these changes
            this.label.classList.remove('__loading');

            //let section know data is ready for it
            this.dispatchEvent(new CustomEvent("location-widget:ordered", {
              bubbles: true,
              detail: { 
                closestStore: this.closestStore, 
                secondClosest: this.secondClosestStore,
              }
            }));
          }
      } catch (error) {
          console.error('Error fetching store data:', error);
      }
  }

  injectCurrentZipcode(section) {
    console.log("debug - injectZipcode");
    let locationElement = section.querySelector('.buff-meganav__location-widget__actions__search label');

    if (locationElement){
      locationElement.innerHTML = locationElement.dataset.prepend + JSON.parse(window.sessionStorage.getItem("userLocation"))?.zipcode;
    }

  }

  //reorder stores so the closest one shows first
  reorderStores(section) {
      console.log("debug - reorderStores");

      let htmlStoreElements = section.querySelectorAll('.buff-meganav__location-widget__stores__store');
      let storesObject = JSON.parse(window.sessionStorage.getItem("stores"));
      
      let stores = storesObject.openStores;
      let closestStoreRelUrl = storesObject.preferred.rel_url;

      if (htmlStoreElements?.length > 0 && stores){
        //vars to find first and second closest stores
        let closestDistance = Infinity;
        let secondDistance = Infinity;

        htmlStoreElements.forEach((storeEl) => {
          const input = storeEl.querySelector("input");
          const relUrl = input?.dataset?.relUrl;
          if (!relUrl) return;

          const match = stores.find(item => item.rel_url === relUrl);
          const d = match?.distance;

          if (typeof d === "number") {
            storeEl.style.order = d.toFixed(0);
            storeEl.querySelector(".buff-meganav__location-widget__stores__store__distance").innerHTML =
              d.toFixed(1) + " miles";

            // update closest + secondClosest correctly
            if (d < closestDistance) {
              this.secondClosestStore = this.closestStore;
              secondDistance = closestDistance;

              this.closestStore = match;
              closestDistance = d;
            } else if (d < secondDistance) {
              // important: this catches "2nd place" even if it never becomes #1
              this.secondClosestStore = match;
              secondDistance = d;
            }
          }

          if (relUrl === closestStoreRelUrl) {
            input.setAttribute("checked", true);
          }
        });
      }
  }
  
  //take all stores hours and inject today's hours
  updateHours(section) {
    
    const hoursText = section.querySelector("#shopify-section-meganav-closest-store-dropdown > .buff-meganav__location-widget__hours")?.textContent;
    const container = section.querySelector(".buff-meganav__location-widget__open-today");


    if (hoursText && container) {
      const holidaysScript = document.querySelector("#Location-widget-holidays");
      const holidays = holidaysScript ? JSON.parse(holidaysScript.textContent) : [];

      const schedule = this.parseSchedule(hoursText);
      const currentDay = this.getCurrentDay();
      const defaultHours = this.getHoursForToday(schedule, currentDay);

      const today = new Date();
      const todayString = today.toLocaleDateString("en-US", {
        timeZone: "America/Chicago", // adjust for your store if needed
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });

      const holidayToday = holidays.find(h => h.date === todayString);

      if (holidayToday) {
        // Use the label directly as a prefix to match: e.g., "June 29th:"
        const regex = new RegExp(`${holidayToday.label}:\\s*([^\\n]+)`);
        const match = hoursText.match(regex);

        if (match) {
          container.innerHTML = `<b>Open today</b> ${match[1].trim()} for ${holidayToday.label}`;
        } else {
          container.innerHTML = `<b>Open today</b> ${defaultHours}`;
        }
      } else {
        container.innerHTML = `<b>Open today</b> ${defaultHours}`;
      }
    }
  }

  //helper function for update hours
  parseSchedule(scheduleText) {
    const lines = scheduleText.trim().split('\n');
    const schedule = {};

    lines.forEach(line => {
      const splitIndex = line.indexOf(':');
      if (splitIndex === -1) return;

      const days = line.slice(0, splitIndex).trim();
      const hours = line.slice(splitIndex + 1).trim();

      if (days.includes(' - ')) {
        const [startDay, endDay] = days.split(' - ').map(day => day.trim());
        const dayList = this.getDaysInRange(startDay, endDay);
        dayList.forEach(day => {
          schedule[day] = hours;
        });
      } else {
        schedule[days] = hours;
      }
    });

    return schedule;
  }

  //helper function for update hours
  getDaysInRange(startDay, endDay) {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const startIndex = daysOfWeek.indexOf(startDay);
    const endIndex = daysOfWeek.indexOf(endDay);
    return daysOfWeek.slice(startIndex, endIndex + 1);
  }

  //helper function for update hours
  getCurrentDay() {
    const today = new Date();
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return daysOfWeek[today.getDay()];
  }

  //helper function for update hours
  getHoursForToday(schedule, day) {
    return schedule[day] || 'Closed'; // Return 'Closed' if the day is not found
  }
}

if (!customElements.get("location-widget")) {
  customElements.define("location-widget", LocationWidget);
}
